import angular from 'angular';
import {navbar} from './navbar/navbar.js';
import {navbarTop} from './navbarTop/navbarTop.js';
import {footer} from './footer/footer.js';
import {inspinia} from './inspinia/inspinia.js';
import {forms} from './forms/forms.js';

const common = angular.module('common', [
    inspinia.name,
    navbar.name,
    navbarTop.name,
    footer.name,
    forms.name
    ]);

export {common};



// WEBPACK FOOTER //
// ./app/components/common/common.js